import { createGuid } from "../../scripts/general_functions";
import { getImageByContentId } from "../../scripts/images";
import { alertsFront } from "./alerts";

let timer;
let secs;
let bgImages = [];
const cloudinaryUrl = 'https://res.cloudinary.com/ssp/image/fetch/g_center,w_1680,h_570,c_fill/';

export const getHeroImages = (url, load = 100, from = 0, callback) => {
    url = window.apiUrl + `/api/PublicContentApi/getcontentlistdescending/${client.clientId}/mal_dynamisk/${load}/${from}/Modified`;
    fetch(url).then(results => results.json()).then(data => {
        callback(data);
    });
}

export const  backgroundSequence = () => {
	window.clearTimeout();
    
	var k = 0;
	for (let i = 0; i < bgImages.length; i++) {
		setTimeout(function(){ 
            if (bgImages[k] !== undefined) {
                document.getElementById('module__hero').style.backgroundImage = `url(${cloudinaryUrl}${bgImages[k]})`;
                document.getElementById('module__hero').style.backgroundSize ="cover";
                if ((k + 1) === bgImages.length) 
                    //k = 0;
                    { setTimeout(function() { backgroundSequence() }, (secs * 1000))} 
                else 
                    k++;
            }			
		}, (secs * 1000) * i)	
	}
}

export const heroFront = (splash, heroDesign = '', heroText = '') => {
    let load = 100;
    let from = 0;
    // let url = `${window.apiUrl}/api/PublicContentApi/getcontentlistdescending/${client.clientId}/mal_dynamisk/${load}/${from}/Modified`;
    let url = `${window.apiUrl}/api/Public/articles/?subscriptionId=${client.clientId}&contentType=17c15981-758d-4d09-a7ee-b2d47d2af6f0&pageType=mal_dynamisk&limit=${load}`;
    let initialPromise = [];

    initialPromise.push(getImages(url));

    Promise.all(initialPromise).then(elm => {
        let heroId = "" + createGuid();
        let style = `background-image: url(${bgImages[0]})`;
        let content = ``;

        if(heroDesign === "narrow") {
            content = `
                <div class="container" id='hero__${heroId}' style='${style}'>
                    <div class="hero__splash">
                        <img src="${splash}" role="none" />
                        <span>${heroText}</span><div>
                    <div>
                </div>
            `;
        }
        else {
            content = `
                <div class="container" id='hero__${heroId}'>
                    <div class="hero__splash">  
                        <img src="${splash}" role="none" />
                        <span>${heroText}</span><div>
                </div>
            `;
        }
        
        let list = []
        bgImages.forEach(function(img_paths){
            var img = new Image();
            img.src = `${cloudinaryUrl}${img_paths}`;
            list.push(img);
            // caches images, avoiding white flash between background replacements
        });

        let heroElement = document.querySelector("#module__hero");
        heroElement.innerHTML = content;
        if(heroDesign !== "narrow") {
            heroElement.style = style;
            if(bgImages.length > 1)  {
                secs = 5;
                backgroundSequence();
            }
        }
    })
    return `<section id="module__hero">...</section>`;
}

export const heroFront2 = (props) => {

    let image = props.image, splash = props.splash, heroDesign = props.style;
    let heroId = "" + createGuid();
    let style = `background-image: url(${image})`;

    let content = ``;
    if(heroDesign == "narrow") {
        content = `
            <div class="container" id='hero__${heroId}' style='${style}'>
                <div class="hero__splash"><img src="${splash}" /><div>
            </div>
        `;
    }
    else {
        content = `
            <div class="container" id='hero__${heroId}'>
                <div class="hero__splash"><img src="${splash}" /><div>
            </div>
        `;
    }

    if(heroDesign == "narrow") {
        return `<section id="module__hero">${content}</section>`;
    }
    else {
        return `<section id="module__hero" style='${style}' >${content}</section>`;
    }
}

const getImages = async (url) => {
    const heroArticleResponse = await fetch(url);
    const heroArticleData = await heroArticleResponse.json();
    if (heroArticleData.totalCount > 0) {
        for(let i=0; i < heroArticleData.listOfContent.length; i++) {
            let item = heroArticleData.listOfContent[i];
            if(item.contentTypeGuid === "17c15981-758d-4d09-a7ee-b2d47d2af6f0") {
                let meta = JSON.parse(decodeURIComponent(item.metaObject));
                if (meta.imageContentId) {
                    const heroImageResponse = await fetch(window.apiUrl + "/api/PublicContentApi/find/" + meta.imageContentId);
                    const heroImageData = await heroImageResponse.json();
                    bgImages.push(heroImageData.path);
                    console.log(heroImageData.path);
                }
            }
        }
    }
}